const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/ProgressStepper.tsx';
import * as React from 'react';
import { css, cx } from '@emotion/css';

interface Props {
    currentStep?: number;
    stepData: boolean[];
    className?: string;
    onStepClick: (stepNumber: number) => void;
}

const ProgressStepper2CSS = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    justify-content: center;

    .ProgressStepper2Step {
        height: 8px;
        border-radius: 3px;
        background-color: #e2e2e2;
        max-width: 36px;
        flex: auto;
        cursor: pointer;

        &.active {
            height: 10px;
            border: 2px solid #1769b6;
            background-color: #75a5d3;
        }
        &.complete {
            background-color: #288639;
        }
    }
`;

export const ProgressStepper = (props: Props) => {
    const { stepData } = props;

    const currentStep = props.currentStep ?? 0;
    const stepCount = stepData.length;

    const renderStep = (_: any, stepNumber: number) => {
        const handleClick = () => {
            props.onStepClick(stepNumber);
        };
        return (
            <div
                key={`step_${stepNumber}`}
                onClick={handleClick}
                className={cx('ProgressStepper2Step', {
                    active: stepNumber === currentStep,
                    complete: stepData[stepNumber],
                })}
            ></div>
        );
    };

    const steps = new Array(stepCount).fill(1).map(renderStep);
    return <div className={cx(ProgressStepper2CSS, props.className)}>{steps}</div>;
};

ProgressStepper.displayName = 'ProgressStepper';
